
import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
@Component
export default class RechargeInfo extends Vue {
    @Prop({ default: 1 })
    private showGuide!: number;
    @Prop({ default: 0 })
    private money!: number;
    private bankSelected = this.rechargeMethods.find(x => x.value === 8);

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }
    get rechargeMethods() {
        return DATA.rechargeMethods;
    }

    get qrLink() {
        return `https://vietqr.app/img?acc=${this.bankSelected.bankNumber}&bank=${this.bankSelected.name}&amount=${this.money}&des=DL${this.userInfo.userId}&holder=${this.bankSelected.ownerName}&template=compact&showinfo=true`;
    }

    private async onSelectBank(bankId: number) {
        this.bankSelected = this.rechargeMethods.find(x => x.value === bankId);
    }
}

